@if (columns) {
  <table
    [ngClass]="{'force-border-bottom': $safeNavigationMigration(pagination?.enabled)}"
    [ngStyle]="table.css"
  >
    <tr>
      @for (column of columns; track colIndex; let colIndex = $index) {
        <th [ngStyle]="column.css">
          @if (bulkSelectActive && isKebabColumn(colIndex)) {
            <span>
              <motn-round-checkbox
                [isChecked]="allPageRowsAreSelected"
                (click)="toggleAllRows()"
              ></motn-round-checkbox>
            </span>
          }

          <span>
            {{column.name}}

            @if (column.infoDialogText) {
              <span (click)="infoDialog(column.infoDialogText)">
                <i class="fa-regular fa-circle-info"></i>
              </span>
            }
          </span>

          @if (column.sortingFn && sortedColumnIndex !== colIndex) {
            <span
              class="sorter"
              (click)="sortColumn(colIndex)"
            >
              <i class="fa-solid fa-sort"></i>
            </span>
          }

          @if (column.sortingFn && sortedColumnIndex === colIndex && sortedColumnDirection === 'up') {
            <span
              class="sorter"
              (click)="sortColumn(colIndex)"
            >
              <i class="fa-duotone fa-solid fa-sort-up"></i>
            </span>
          }

          @if (column.sortingFn && sortedColumnIndex === colIndex && sortedColumnDirection === 'down') {
            <span
              class="sorter"
              (click)="sortColumn(colIndex)"
            >
              <i class="fa-duotone fa-solid fa-sort-down"></i>
            </span>
          }
        </th>
      }
    </tr>

    @for (row of currentPageRows; track row.context) {
      <motn-sort-table-row
        [ngClass]="{'clickable': row.clickCallback}"
        [row]="row"
        [columns]="columns"
        (click)="rowClicked(row)"
      ></motn-sort-table-row>
    }
  </table>
}

@if (pagination?.enabled) {
  <motn-paginator
    [autoScroll]="autoScroll"
    [disableUrlUpdate]="disableUrlUpdate"
    [totalElementQty]="totalRowCount"
    [elementsPerPage]="elementsPerPage"
    [pageOptionsQty]="maxPageOptions"
    [pageNumber]="currentPageNumber"
    (pageNumberOutput$)="changePageNumber($event)"
  ></motn-paginator>
}

@if (bulkSelectActive) {
  <motn-bulk-action-tool
    [selectedValues]="bulkSelectedValues"
    [capabilities]="bulkSelectCapabilities"
    (done$)="cancelBulkSelect()"
  ></motn-bulk-action-tool>
}
